import { FlexibleColumnLayout } from '@fundamental-ngx/core';

export class DisplayedColumn {
    key: string;
    title: string;
    checked: boolean;
    disabled: boolean;
    visibleIn: FlexibleColumnLayout[];

    constructor(init?: Partial<DisplayedColumn>) {
        Object.assign(this, init);
    }
}
